class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    this.updateOptions();

    const changedInput = event && event.target ? event.target : null;
    const directVariantId = changedInput ? changedInput.getAttribute('data-variant-id') : null;

    if (directVariantId) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return String(variant.id) === String(directVariantId);
      });
    } else {
      this.updateMasterId();
    }

    this.toggleAddButton(true, '', false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index] === option)
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    var featuredId = this.currentVariant.featured_media.id;

    if (document.querySelector('.media-thumb')) {
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(item) {
        var mediaId = item.dataset.id;
        if (String(mediaId) === String(featuredId)) {
          if (typeof Swiper !== 'undefined' && document.querySelector('.media-nav')?.swiper) {
            document.querySelector('.media-nav').swiper.slideTo(item.dataset.index, 1000, false);
          }
        }
      });
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  getRelatedAddButtons() {
    const formId = `product-form-${this.dataset.section}`;
    return document.querySelectorAll(
      `#${formId} [name="add"], [name="add"][form="${formId}"]`
    );
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldCount = fieldsets.length;
    let selectedCount = 0;

    fieldsets.forEach(function(fieldset) {
      var checked = fieldset.querySelector('input:checked');
      if (checked) selectedCount++;
    });

    this.options = fieldsets.map((fieldset) => {
      if (selectedCount >= fieldCount) {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
      return undefined;
    });
  }

  renderProductInfo() {
    if (!this.currentVariant) return;

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })
      .catch(console.error);
  }

  toggleAddButton(disable = true, text) {
    const addButtons = this.getRelatedAddButtons();

    addButtons.forEach((addButton) => {
      const addButtonText = addButton.querySelector('span');

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text && addButtonText) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
      }
    });
  }

  setUnavailable() {
    const addButtons = this.getRelatedAddButtons();

    addButtons.forEach((addButton) => {
      const addButtonText = addButton.querySelector('span');
      addButton.setAttribute('disabled', 'disabled');
      if (addButtonText) addButtonText.textContent = window.variantStrings.unavailable;
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);

    return this.variantData;
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}

function variant_drodown() {
  document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown) {
    if (dropdown.dataset.bound === 'true') return;
    dropdown.dataset.bound = 'true';

    const trigger = dropdown.querySelector('.variant-dropdown');
    if (!trigger) return;

    trigger.addEventListener('click', function(event) {
      event.preventDefault();
      dropdown.classList.toggle('active');
    });

    dropdown.querySelectorAll('input[type="radio"]').forEach(function(input) {
      input.addEventListener('change', function(event) {
        dropdown.classList.remove('active');
        trigger.innerHTML = event.currentTarget.value;
      });
    });
  });
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`
    }
  };
}

function closeMobileProductUi() {
  document.querySelectorAll('.size-chart-parent-var').forEach(function(el) {
    el.classList.remove('active');
  });

  document.querySelectorAll('.mobile-select-size-variants').forEach(function(el) {
    el.classList.remove('active');
  });

  document.querySelectorAll('.black-overlay-mobile').forEach(function(el) {
    el.style.display = 'none';
  });

  document.documentElement.classList.remove('overflow-hidden');
}

function getFormFromButton(button) {
  let form = button.closest('form');

  if (!form && button.hasAttribute('form')) {
    form = document.getElementById(button.getAttribute('form'));
  }

  return form;
}

function handleAddToCartClick(button, evt) {
  evt.preventDefault();

  if (button.hasAttribute('disabled') || button.disabled) return;

  const form = getFormFromButton(button);
  if (!form) return;

  let variantId = null;

  const variantInput = form.querySelector('input[name="id"]');
  if (variantInput && variantInput.value) {
    variantId = variantInput.value;
  }

  if (!variantId) return;

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(form);
  formData.set('id', variantId);
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        const errorBox = form.querySelector('.product-form-error') || document.querySelector('.product-form-error');
        if (errorBox) {
          errorBox.innerHTML = response.description || response.message || 'Error';
          setTimeout(function() {
            errorBox.innerHTML = '';
          }, 2000);
        }
        return;
      }

      closeMobileProductUi();
      document.body.classList.add('open-drawer');

      if (window.innerWidth < 576) {
        document.documentElement.classList.remove('overflow-hidden');
      }

      if (typeof load_cart === 'function') {
        load_cart();
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(console.error);
}

function bindAddToCart() {
  if (document.body.dataset.addToCartDelegated === 'true') return;
  document.body.dataset.addToCartDelegated = 'true';

  document.addEventListener('click', function(evt) {
    const button = evt.target.closest('.product-addcart');
    if (!button) return;

    handleAddToCartClick(button, evt);
  });
}

function product_slider() {
  if (!document.querySelector('.media-slider') || typeof Swiper === 'undefined') return;

  if (document.querySelector('.media-thumb') && !document.querySelector('.media-thumb')?.swiper) {
    new Swiper('.media-thumb', {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
  }

  if (document.querySelector('.media-nav') && !document.querySelector('.media-nav')?.swiper) {
    new Swiper('.media-nav', {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination'
      },
      thumbs: {
        swiper: document.querySelector('.media-thumb')?.swiper
      }
    });
  }
}

function initProductScripts() {
  product_slider();
  variant_drodown();
  bindAddToCart();
}

initProductScripts();

document.addEventListener('shopify:section:load', function() {
  initProductScripts();
});